import type { WithCollapsedContact } from './email-autocomplete/model';
import isString from 'lodash/isString';
import uniq from 'lodash/uniq';
import { ContactAPI } from '@/shared/legacy/api/contact';
import { SearchAPI } from '@/shared/legacy/api/search';

export const getCoworkers = (includeResources: boolean) => {
  const params: Parameters<typeof SearchAPI.searchContacts>[0] = { exclude: ['contacts'] };
  if (!includeResources) {
    params.exclude!.push('resources');
  }
  return SearchAPI.searchContacts(params);
};

export const hideContact = (collapsedContact: WithCollapsedContact) => {
  const { email, name, collapsedContacts } = collapsedContact;

  const allNames = collapsedContacts
    .map((contact) => contact.name)
    .filter((contact): contact is string => isString(contact));

  if (isString(name)) {
    allNames.push(name);
  }

  const names = uniq(allNames);

  return ContactAPI.hide({
    email,
    names
  });
};
